<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-user-research`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.5 4C30.717 4 39 12.283 39 22.5c0 3.31-.877 6.45-2.434 9.175l8.73 7.324a1 1 0 01.123 1.409l-1.285 1.532a1 1 0 01-1.41.123l-8.512-7.141a18.473 18.473 0 01-7.752 5.096l-1.288-3.787A14.506 14.506 0 0035 22.5C35 14.492 28.508 8 20.5 8S6 14.492 6 22.5H2C2 12.283 10.283 4 20.5 4zM13 22a8 8 0 015.973 13.322A9.996 9.996 0 0124 44h-4a6 6 0 00-6-6h-2a6 6 0 00-6 6H2a9.996 9.996 0 015.027-8.678A8 8 0 0113 22zm-4 8a4 4 0 118 0 4 4 0 01-8 0z"/></svg>
</template>
<script>

export default {
  name: 'IconUserResearch',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
